import styled from 'styled-components';
import MIt01 from 'dc/MIt01';

export const Wrapper = styled.div`
  min-width: 320px;
  border-right: 1px solid #eceff1;
`;

export const MenuSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 0;
`;

export const MenuItem = styled(MIt01)``;
